/* Researched Elements cart helpers (product owner, 10/08/26). Loaded as a module on every page from layout/theme.liquid.
   1. Free shipping progress in the cart drawer and on the cart page (threshold $249, as stated in the announcement bar).
   2. A click on the desktop scrim closes the drawer.
   3. Quick add for the compact product cards (form[data-re-quick-add]); without JavaScript the form posts to /cart/add as usual. */
const FREE_SHIP_CENTS = 24900;
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

function money(cents) {
  const whole = cents % 100 === 0;
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(cents / 100);
  } catch (e) { return '$' + (cents / 100).toFixed(whole ? 0 : 2); }
}

/* ---------- 1. Free shipping progress ---------- */
let cartCache = null;
let inflight = null;
function getCart(force) {
  if (!force && cartCache) return Promise.resolve(cartCache);
  if (inflight) return inflight;
  inflight = fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then((r) => r.json())
    .then((c) => { cartCache = c; inflight = null; return c; })
    .catch(() => { inflight = null; return null; });
  return inflight;
}
const TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 6.5h11v9.5h-11z"/><path d="M13.5 9.5h4l3 3.2v3.3h-7"/><circle cx="6.5" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/></svg>';
function shipHTML(total) {
  const left = FREE_SHIP_CENTS - total;
  const pct = Math.max(4, Math.min(100, Math.round((total / FREE_SHIP_CENTS) * 100)));
  const msg = left > 0
    ? `<strong>${money(left)}</strong>&nbsp;away from free shipping on orders of ${money(FREE_SHIP_CENTS)} or more`
    : `Your order qualifies for <strong>free shipping</strong>`;
  return { done: left <= 0, pct, html: `<p class="re-ship__msg">${TRUCK}<span>${msg}</span></p><div class="re-ship__bar" aria-hidden="true"><span class="re-ship__fill"></span></div>` };
}
let selfMutating = false;
function quiet() { selfMutating = true; setTimeout(() => { selfMutating = false; }, 0); }
function placeShip(container, before, total) {
  if (!container) return;
  quiet();
  let box = container.querySelector(':scope > .re-ship');
  const s = shipHTML(total);
  if (!box) {
    box = document.createElement('div');
    box.className = 're-ship';
    box.setAttribute('role', 'status');
    box.setAttribute('aria-live', 'polite');
    container.insertBefore(box, before && before.parentNode === container ? before : container.firstChild);
  }
  if (box.dataset.total !== String(total)) {
    box.dataset.total = String(total);
    box.innerHTML = s.html;
    box.classList.toggle('is-done', s.done);
  }
  const fill = box.querySelector('.re-ship__fill');
  if (fill) requestAnimationFrame(() => fill.style.setProperty('--p', s.pct + '%'));
}
function renderShip(force) {
  const drawerContent = document.querySelector('#cart-drawer .cart-drawer__content');
  const pageItems = document.querySelector('.cart-page__items');
  const drawerEmpty = !!document.querySelector('#cart-drawer .cart-drawer--empty');
  const pageEmpty = !!document.querySelector('.cart-page--empty');
  if ((!drawerContent || drawerEmpty) && (!pageItems || pageEmpty)) {
    if (document.querySelector('.re-ship')) { quiet(); document.querySelectorAll('.re-ship').forEach((n) => n.remove()); }
    return;
  }
  getCart(force).then((cart) => {
    if (!cart) return;
    const total = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    if (!cart.item_count) { quiet(); document.querySelectorAll('.re-ship').forEach((n) => n.remove()); return; }
    if (drawerContent && !drawerEmpty) placeShip(drawerContent, drawerContent.firstElementChild, total);
    if (pageItems && !pageEmpty) placeShip(pageItems, pageItems.firstElementChild, total);
  });
}
let shipTimer = 0;
function queueShip(force) { clearTimeout(shipTimer); shipTimer = setTimeout(() => renderShip(force), 120); }

function watch() {
  const targets = [document.getElementById('cart-drawer'), document.querySelector('.cart-page')].filter(Boolean);
  const mo = new MutationObserver((list) => {
    if (selfMutating) return;
    for (const m of list) {
      const t = m.target;
      if (t.nodeType === 1 && t.closest && t.closest('.re-ship')) continue;
      if (m.type === 'attributes' && m.attributeName === 'open') { if (t.hasAttribute('open')) queueShip(true); continue; }
      queueShip(true);
      return;
    }
  });
  targets.forEach((t) => mo.observe(t, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] }));
  if (document.querySelector('.cart-page')) queueShip(false);
}

/* ---------- 2. Desktop scrim (aria-expanded on the cart button is kept in step by an inline script in layout/theme.liquid) ---------- */
document.addEventListener('click', (e) => {
  const d = document.getElementById('cart-drawer');
  if (d && e.target === d && d.hasAttribute('open') && typeof d.close === 'function') d.close();
});

/* ---------- 3. Quick add on compact cards ---------- */
function announce(text) {
  let live = document.getElementById('re-live');
  if (!live) {
    live = document.createElement('div');
    live.id = 're-live'; live.className = 'visually-hidden'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
    document.body.appendChild(live);
  }
  live.textContent = '';
  setTimeout(() => { live.textContent = text; }, 30);
}
document.addEventListener('submit', async (e) => {
  const form = e.target && e.target.closest ? e.target.closest('form[data-re-quick-add]') : null;
  if (!form || form.dataset.busy) return;
  e.preventDefault();
  const btn = form.querySelector('button');
  form.dataset.busy = '1';
  if (btn) btn.setAttribute('aria-busy', 'true');
  let posted = false;
  try {
    const ev = await import('@shopify/events');
    const fd = new FormData(form);
    const ids = [...document.querySelectorAll('cart-items-component')].map((x) => x.dataset.sectionId).filter(Boolean);
    if (ids.length) fd.append('sections', [...new Set(ids)].join(','));
    const deferred = ev.CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new ev.CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: String(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }],
      promise: deferred.promise,
    }));
    posted = true;
    const res = await fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
    const cart = await getCart(true);
    deferred.resolve({
      cart: cart ? ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : undefined,
      detail: { items: cart ? cart.items : [], source: 're-quick-add', sourceId: 're-quick-add', itemCount: 1, sections: res && res.sections, didError: !!(res && res.status) },
    });
    if (res && res.status) { announce(res.description || res.message || 'This item could not be added.'); return; }
    announce('Added to your cart');
    if (btn) { const span = btn.querySelector('span') || btn; const old = span.textContent; span.textContent = 'Added'; setTimeout(() => { span.textContent = old; }, 1800); }
    const drawer = document.getElementById('cart-drawer');
    if (drawer && !drawer.hasAttribute('open') && typeof drawer.open === 'function') setTimeout(() => { if (!drawer.hasAttribute('open')) drawer.open(); }, 350);
    queueShip(true);
  } catch (err) {
    if (!posted) { form.removeAttribute('data-re-quick-add'); form.submit(); return; }
    announce('That did not go through. You can try again.');
  } finally {
    delete form.dataset.busy;
    if (btn) btn.removeAttribute('aria-busy');
  }
});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
else watch();
